import { IDockviewPanelProps } from "dockview-react";
import React from "react";
import { api } from "./utils/api";
import { Instrument } from "./RealtimeChart";

export const TwitterNotifications = (props: IDockviewPanelProps) => {
  const [accounts, setAccounts] = React.useState<string[]>([]);
  const [newAccountId, setNewAccountId] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    fetchAccounts();
  }, []);

  function fetchAccounts() {    
    setIsLoading(true);

    api
      .get(`/twitter-notifications`)
      .then((response) => {
        setAccounts(response.data);
      })
      .catch((error) => {
        console.error("Error fetching twitter accounts:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  function handleAddAccount(e: React.FormEvent) {
    e.preventDefault();
    if (!newAccountId.trim()) return;
    
    setIsLoading(true);
    setNewAccountId("");
    
    api
      .post(`/twitter-notifications/${newAccountId}`)
      .then(() => {
        fetchAccounts();
      })
      .catch((error) => {
        console.error("Error adding twitter account:", error);
        setIsLoading(false); 
      })
  }

  function handleDeleteAccount(accountId: string) {
    setIsLoading(true); 

    api
      .delete(`/twitter-notifications/${accountId}`)
      .then(() => {
        fetchAccounts();
      })
      .catch((error) => {
        console.error("Error deleting twitter account:", error);
        setIsLoading(false); 
      })
  }

  return (
    <div className="p-4">      
      <form onSubmit={handleAddAccount} className="mb-4 flex gap-2">
        <input
          type="text"
          value={newAccountId}
          onChange={(e) => setNewAccountId(e.target.value)}
          placeholder="Enter account ID"
          className="border rounded px-2 py-1 flex-1"
        />
        <button
          type="submit"
          className="btn btn-primary"
        >
          Add
        </button>
      </form>

      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <div className="list-disc list-inside">
          {accounts.map((accountId, index) => (
            <div key={index} className="flex items-center justify-between mb-2">
              <span>{accountId}</span>
              <button
                onClick={() => handleDeleteAccount(accountId)}
                className="btn btn-default"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};